export let colHrNumDaysPerWeek = {
                                    colId: 'hrNumDaysPerWeek',
                                    headerName: 'HR - Number of Days Per Week',
                                    field: 'hrNumDaysPerWeek',
                                    width: 50,
                                    type: 'number',
                                    sortable: true
                                };

export let colHrWhichDaysPerWeek = {colId: 'hrWhichDaysPerWeek',
                                headerName: 'HR - Which Days per Week',
                                field: 'hrWhichDaysPerWeek',
                                width: 50,
                                sortable: true };

export let colHrHoursPerWeek = {colId: 'hrHoursPerWeek', headerName: 'HR - Hours per week',
                              field: 'hrHoursPerWeek',
                              width: 50,
                              type: 'number',
                              sortable: true };
export let colHrProfessionalServices = {colId: 'hrProfessionalServices', headerName: 'HR - Professional Services',
                              field: 'hrProfessionalServices',
                              width: 50,
                              sortable: true };
export let colHrCmeDays = {colId: 'hrCmeDays', headerName: 'HR - CME Days',
                              field: 'hrCmeDays',
                              width: 50,
                              sortable: true };
export let colHrCmeAllowanceAmount = {colId: 'hrCmeAllowanceAmount', headerName: 'HR - CME Allowance Amount',
                              field: 'hrCmeAllowanceAmount',
                              width: 50,
                              type: 'number',
                              sortable: true };
export let colHrSickDaysPerYear = {colId: 'hrSickDaysPerYear', headerName: 'HR - Sick Days per Year',
                              field: 'hrSickDaysPerYear',
                              width: 50,
                              type: 'number',
                              sortable: true };
export let colHrVacationDaysPerYear = {colId: 'hrVacationDaysPerYear', headerName: 'HR - Vacation Days per Year',
                              field: 'hrVacationDaysPerYear',
                              width: 50,
                              type: 'number',
                              sortable: true };
export let colHrCombinedSickVacationDays = {colId: 'hrCombinedSickVacationDays',
                                            headerName: 'HR - Combined Sick Vacation Days',
                                            field: 'hrCombinedSickVacationDays',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };



export let allColumns = [
    colHrNumDaysPerWeek,
    colHrWhichDaysPerWeek,
    colHrHoursPerWeek,
    colHrProfessionalServices,
    colHrCmeDays,
    colHrCmeAllowanceAmount,
    colHrSickDaysPerYear,
    colHrVacationDaysPerYear,
    colHrCombinedSickVacationDays
];



export let columnSelectList = [
    {
        value: colHrNumDaysPerWeek,
        viewValue: colHrNumDaysPerWeek.headerName
    },
    {
        value: colHrWhichDaysPerWeek,
        viewValue: colHrWhichDaysPerWeek.headerName
    },
    {
        value: colHrHoursPerWeek,
        viewValue: colHrHoursPerWeek.headerName
    },
    {
        value: colHrProfessionalServices,
        viewValue: colHrProfessionalServices.headerName
    },
    {
        value: colHrCmeDays,
        viewValue: colHrCmeDays.headerName
    },
    {
        value: colHrCmeAllowanceAmount,
        viewValue: colHrCmeAllowanceAmount.headerName
    },
    {
        value: colHrSickDaysPerYear,
        viewValue: colHrSickDaysPerYear.headerName
    },
    {
        value: colHrVacationDaysPerYear,
        viewValue: colHrVacationDaysPerYear.headerName
    },
    {
        value: colHrCombinedSickVacationDays,
        viewValue: colHrCombinedSickVacationDays.headerName
    },
];